"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const core_1 = require("@material-ui/core");
const classnames_1 = require("classnames");
const react_i18next_1 = require("react-i18next");
const ListCard_1 = require("../card/ListCard");
const assets_1 = require("../config/assets");
const config_1 = require("../config/config");
const RewardCard = ({ reward, onRewardSelect, disableCornerIcon, t, classes, banner }) => {
    var _a;
    const cornerIcon = {
        icon: config_1.config.internalConfig.REWARDS_ICON,
        iconType: 'custom',
        contentColor: banner && banner.styleType && banner.styleType === 'GrayedOut'
            ? config_1.config.themeColors.black.alpha(0.35).toString()
            : config_1.config.themeColors.cornerColors.rewardContrast.hex(),
        trianglePosition: { top: 0, left: 0 },
        triangleType: 'topLeft',
        triangleBackgroundColor: banner && banner.showBanner
            ? config_1.config.themeColors.white.toString()
            : config_1.config.themeColors.cornerColors.reward.hex(),
        triangleSize: 88
    };
    const onPress = () => {
        onRewardSelect(reward);
    };
    let title = `${t('reward.redeemFor')}: ${reward.num_points.toPointsFormatWithUnit()}`;
    let description = !!reward.extra_data && reward.extra_data.preview_text
        ? reward.extra_data.preview_text
        : reward.description;
    let contentClass = classes.contentBody;
    if (reward.isInformationOnly) {
        title = t('informationOnlyTile.didYouKnow').toUpperCase();
        cornerIcon.icon = undefined;
        cornerIcon.triangleBackgroundColor = config_1.config.themeColors.white.hex();
        cornerIcon.image = assets_1.assets.internalAssets.starImg;
        description = undefined;
        contentClass = (0, classnames_1.default)(classes.contentBody, classes.informationOnly);
    }
    return ((0, jsx_runtime_1.jsx)(ListCard_1.default, { onClick: onPress, image: reward.image, imageTitle: config_1.config.internalConfig.SHOW_IMAGE_PREFIX ? 'Image of reward ' + reward.title : reward.title, text: ((_a = reward === null || reward === void 0 ? void 0 : reward.extra_data) === null || _a === void 0 ? void 0 : _a.display_name) ? reward.extra_data.display_name : reward.title, title: title, titleColor: 'primary', textDescription: description, cornerIcon: cornerIcon, showBanner: banner && banner.showBanner, bannerText: banner && banner.bannerText ? banner.bannerText : undefined, bannerStyleType: banner && banner.styleType ? banner.styleType : undefined, disableCornerIcon: disableCornerIcon, contentClass: contentClass }));
};
const styles = () => (0, core_1.createStyles)({
    contentBody: {
        minHeight: '8em'
    },
    informationOnly: {
        '& p': {
            display: '-webkit-box',
            '-webkit-line-clamp': '2',
            '-webkit-box-orient': 'vertical',
            whiteSpace: 'break-spaces',
            maxHeight: '2.2em'
        }
    }
});
exports.default = (0, core_1.withStyles)(styles)((0, react_i18next_1.withTranslation)()(RewardCard));
//# sourceMappingURL=RewardCard.js.map